import _, { get, set } from 'lodash';
import { ajaxApi, ajaxApiGet,fileDownloadApiNew } from '@/server/index'
import { getSid } from '@/public/utils'
import common from "@/public/common";


var apiHost = common.SapUrl


export const fetchSystemInvoice = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-system/get-system-invoice`,
        params: params,
    })
}
export const fetchSigoCompany = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/query-sigo-company-by-sid`,
        params: {sid:getSid()},
    })
}

export const fetchEnums = (params = {}) => {
    return ajaxApiGet({
        url: `${apiHost}invoice/get-enums`,
        params: {},
    })
}

export const fetchInvoicePageList = (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/query-page-list`,
        params: params,
    })
}

export const fetchInvoicePageExportSys = (params = {},filename) => {
    return fileDownloadApiNew({
        url: `${apiHost}invoice/query-page-list/export-sys`,
        param: params,
        filename:filename
    })
}

export const fetchInvoicePageExportManual = (params = {},filename) => {
    return fileDownloadApiNew({
        url: `${apiHost}invoice/query-page-list/export-manual`,
        param: params,
        filename:filename
    })
}






// WEBPACK FOOTER //
// ./src/pages/billVerification/match/common/api.js